import React from "react";
import "./Button.css";

const Button = ({ text, type = 1, className, onClick, children, style, ...props }) => {
    let bgColor = `bg-color1 hover:bg-color1-hover`;
    let textColor = "text-white";

    if (type === 2) {
        bgColor = "bg-color2 hover:bg-color2-hover";
        textColor = "text-black";
    } else if (type === 3) {
        bgColor = "bg-color3 hover:bg-color3-hover";
    } else if (type === 4) {
        bgColor = "bg-color4 hover:bg-color4-hover";
    } else if (type === 5) {
        bgColor = "bg-color5 hover:bg-color5-hover";
    } else if (type === 6) {
        bgColor = "bg-color6 hover:bg-color6-hover";
    } else if (type === 7) {
        bgColor = "bg-colorPrimary ";
    } else if (type === 8) {
        bgColor = "bg-quartenaryBlue hover:bg-colorPrimary2-hover";
    } else if (type === 9) {
        bgColor = "bg-rebrandRcBlueTwo hover:brightness-105";
    } else if (type === 10) {
        bgColor = "!bg-rebrandRcYellow hover:brightness-105 !text-rebrandRcBlue";
    } else if (type === 11) {
        bgColor = "!text-rebrandRcLightBlue hover:brightness-105 bg-transparent";
    } else if (type === 12) {
        bgColor = "!text-white hover:text-white bg-rebrandRcRed";
    } else if (type === 13) {
        bgColor = "bg-rebrandRcBlue hover:brightness-105";
    } else if (type === 14) {
        bgColor = "bg-rebrandGreenGradient hover:brightness-105 text-white";
    } else if (type === 15) {
        bgColor = "btn-pitch hover:brightness-105";
    } else if (type === 16) {
        bgColor = "";
    } else if (type === 17) {
        bgColor = "bg-white !text-rebrandRcMiscText border border-[var(--rebrandRcMiscText)]";
    } else if (type === "disabled") {
        bgColor = "bg-[#D0D0D3]";
    }

    return (
        <button
            className={`rounded ${bgColor} ${textColor} transition-all duration-300 block font-darwinProSemiBold leading-6 px-6 py-4 text-center text-[1.25rem] break-words ${className}`}
            onClick={onClick}
            style={style}
            {...props}
        >
            {text || children}
        </button>
    );
};

export default Button;
